import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export function ProjectsPage() {
  return (
    <section
      id="projects"
      className="min-h-screen scroll-mt-24 bg-neutral-950 pb-24 pt-32 text-neutral-100 md:pt-36"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <p className="text-xs uppercase tracking-[0.22em] text-white">
          Projects
        </p>
        <h1 className="mt-3 text-2xl font-semibold tracking-tight md:text-3xl">
          What we are building
        </h1>
        <p className="mt-3 max-w-3xl text-sm text-white md:text-base">
          A look at the platforms Valinor Dynamics is actively developing for dual-tech
          security and defense applications.
        </p>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
          <Link
            to="/projects/scout"
            className="group flex flex-col overflow-hidden rounded-xl border border-white/15 bg-black transition hover:border-white/40 hover:shadow-[0_0_30px_rgba(255,255,255,0.08)]"
          >
            <div className="flex items-center justify-center bg-neutral-900 p-6">
              <img
                src="/rover1.png"
                alt="Valinor Dynamics Scout rover"
                className="h-56 w-auto object-contain transition duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col gap-3 px-6 py-6">
              <p className="text-xs uppercase tracking-[0.22em] text-neutral-500">
                Autonomous Ground Vehicle
              </p>
              <h2 className="text-2xl font-semibold tracking-tight">The Scout</h2>
              <p className="text-sm leading-6 text-white">
                A compact autonomous patrol rover built around LiDAR sensing, onboard
                vision, and a rugged four-wheel base. Designed to cover ground that fixed
                cameras and human patrols cannot.
              </p>
              <span className="mt-2 inline-flex items-center gap-2 text-sm font-medium text-white transition group-hover:text-white">
                Learn more
                <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        </div>

        <p className="mt-10 text-sm font-medium uppercase tracking-[0.22em] text-white">
          More projects coming out.
        </p>
      </div>
    </section>
  );
}
